import axios from 'axios'

export function registerUser(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function loginUser(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/login', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function samlLoginUser(idpName, redirect, referer = '') {
    if (redirect) {
        return axios.get(process.env.VUE_APP_API_SAML_URL + '/' + idpName + '/login?redirect=' + redirect + '&referer=' + referer, {
            headers: {
                'Content-Type': 'application/vnd.api+json',
            },
        })
    } else {
        return axios.get(process.env.VUE_APP_API_SAML_URL + '/' + idpName + '/login',  + '?referer=' + referer, {
            headers: {
                'Content-Type': 'application/vnd.api+json',
            },
        })
    }

}

export function getUser(userId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getUserProfile(token) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/profile', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Authorization': 'Bearer ' + token
        },
    })
}

export function logoutUser() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/logout', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function verifyUser(verificationUrl, signature) {
    return axios.get(verificationUrl + '&signature=' + signature, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function resendEmail(token) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/email/resend', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Authorization': 'Bearer ' + token
        },
    })
}
export function checkEmail(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/password/email', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',

        },
    })
}

export function tokenCheck(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/password/check', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',

        },
    })
}
export function resetPassword(data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/password/reset', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',

        },
    })
}
export function setAvatar(userId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId + '/-actions/set-avatar', data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function deleteAvatar(userId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId + '/-actions/delete-avatar', {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}

export function updateUser(userId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function verifyEmailChange(verificationUrl, signature) {
    return axios.get(verificationUrl + '&signature=' + signature, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function dismissEmailChange(userId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId + '/-actions/dismiss-email-changes', {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}
export function checkUserBeforeDeletion() {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/check-before-deletion', {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
    })
}
export function deleteUserAccount(userId, data) {
    return axios.patch(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/' + userId, data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function registerUserGettingStarted(data){
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/getting-started', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getLoginURLForGoogle(){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/google', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function getUserFromGoogle(queryString){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/google/callback' + queryString, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function redirectUserAfterSocialLogin(data, token){
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/after-social-login', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Authorization': 'Bearer ' + token
        },
    })
}

export function redirectUserAfterSocialLoginAcceptGDPR(data, token){
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/users/-actions/after-social-login-direct', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Authorization': 'Bearer ' + token
        },
    })
}

export function getUserNotifications(size, page) {
    if(Object.keys(page).length){
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/notifications?page[after]=' + page.to + '&page[limit]=' + size, {

            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }else{
        return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/notifications?page[limit]=' + size, {

            headers: {
                'Content-Type': 'application/vnd.api+json'
            },
        })
    }
}

export function markAllNotificationsAsSeen(){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/notifications/-actions/notifications-seen', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function markAllNotificationsAsRead(){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/notifications/-actions/read-all-notifications', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function markNotificationAsRead(notificationId){
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/notifications/-actions/read-notification?notification=' + notificationId, {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}